import { __awaiter, __generator } from "tslib";
import { CreationError, } from '@office-start/create-types';
import { getFileTypeNameFromType } from '@office-start/file-utility';
import { launchContent } from '@office-start/launcher-service';
// Temporary wrapper class on launcherService. Revisit after LauncherService finalized
export function launchContentWrapper(candidate, fileUrlModel, targetTab, linkTarget, template, templateDriveId) {
    var _a, _b, _c, _d;
    return __awaiter(this, void 0, void 0, function () {
        var appName, document_1, launchResult, error_1;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _e.trys.push([0, 3, , 4]);
                    if (!fileUrlModel) return [3 /*break*/, 2];
                    appName = getFileTypeNameFromType(candidate.fileType);
                    document_1 = {
                        canonicalUrl: fileUrlModel.canonicalUrl,
                        webUrl: fileUrlModel.webUrl,
                        app: appName,
                        attribution: fileUrlModel.canonicalUrl,
                        url: fileUrlModel.canonicalUrl,
                        extension: (_a = candidate.fileExtension) !== null && _a !== void 0 ? _a : '',
                        title: (_b = fileUrlModel.fileName) !== null && _b !== void 0 ? _b : '',
                        id: fileUrlModel.docId || '',
                        fileType: candidate.fileType,
                        isRedeemed: true, //TODO: if this value is not set to true, current launcher service won't try opening in client app. Revisit if needed.
                    };
                    return [4 /*yield*/, launchContent({
                            action: 'OpenDocument',
                            document: document_1,
                            useWebUrl: true,
                            wdOriginType: "NEW" /* WdOriginType.New */,
                            newContentParams: template
                                ? {
                                    templateItemId: template.AssetId,
                                    templateDriveId: templateDriveId,
                                    templateBinaryUrl: template.TemplateBinaryUrl,
                                }
                                : undefined,
                            linkTarget: targetTab ? '_top' : linkTarget,
                            targetTab: targetTab !== null && targetTab !== void 0 ? targetTab : undefined,
                        })];
                case 1:
                    launchResult = _e.sent();
                    if (!launchResult.result ||
                        launchResult.result === 'OpenNull' ||
                        launchResult.result === 'OpenUndefined') {
                        throw new CreationError("Open blocked by pop-up blocker for the newly created ".concat(appName, " file."), "OpenBlockedByPopupBlocker" /* CreateDocumentResultType.OpenBlockedByPopupBlocker */);
                    }
                    if (!launchResult.success) {
                        throw new CreationError((_c = launchResult.message) !== null && _c !== void 0 ? _c : "Failed to launch newly created ".concat(appName, " file."), "OpenNewDocFailed" /* CreateDocumentResultType.OpenNewDocFailed */);
                    }
                    _e.label = 2;
                case 2: return [3 /*break*/, 4];
                case 3:
                    error_1 = _e.sent();
                    // TODO: logging if needed
                    // try loading in web if this is pwa. Should remove when launcher service is verified.
                    return [2 /*return*/, Promise.resolve({
                            type: (_d = error_1.type) !== null && _d !== void 0 ? _d : "OpenNewDocFailed" /* CreateDocumentResultType.OpenNewDocFailed */,
                            documentWebUrl: fileUrlModel.webUrl,
                            fileType: candidate.fileType,
                        })];
                case 4: return [2 /*return*/, Promise.resolve({ type: "GoToBlankDoc" /* CreateDocumentResultType.GoToBlankDoc */ })];
            }
        });
    });
}
//# sourceMappingURL=launchContentWrapper.js.map